import { Component, OnInit } from '@angular/core';
import { IMyOptions } from 'mydatepicker';
import { IMyDrpOptions } from 'mydaterangepicker';
import { PayorsService } from '../payors/payors.service';
import { ReportsService } from './reports.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {

  protected myDatePickerOptions: IMyDrpOptions = {
    dateFormat: 'yyyy-mm-dd',
    editableDateRangeField: false,
    markCurrentDay: true
  };
  protected rangeDate;
  protected selectedPayor: any;
  protected payors: any[];

  constructor(
    private _payorService: PayorsService,
    private _toast: ToastrAlertHelper,
    private _service: ReportsService,
    private _loading: T2LoadingService
    ) {}

  ngOnInit() {
    this.getPayors();
  }

  private getPayors() {
    this._payorService.getPayorsAll().subscribe(
      data => {
        this.payors = data;
      }
    )
  }

  private getFormatted(date) {
    const month = date.month < 10 ? '0'+date.month : date.month;
    const day = date.day < 10 ? '0'+date.day : date.day;
    return `${date.year}-${month}-${day}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/reports/reports.component.ts